export const en: Record<string, string> = {
  // Menu
  'menu.subtitle': 'A block world adventure',
  'menu.playerName': 'Player name',
  'menu.namePlaceholder': 'Enter your name...',
  'menu.play': 'Play',
  'menu.footer': 'v0.3 — Multiplayer · <a href="/stats" id="stats-link">Server stats</a>',
  'menu.blogPill': '\u{1F4DD} Making-of blog post',
  'menu.online.none': 'No players online',
  'menu.online.one': '1 player online',
  'menu.online.many': '{count} players online',
  'menu.defaultName': 'Player',

  // Character customizer
  'customizer.type': 'Type',
  'customizer.hair': 'Hair',
  'customizer.skin': 'Skin',
  'customizer.shirt': 'Shirt',
  'customizer.pants': 'Pants',
  'customizer.shoes': 'Shoes',

  // Controls
  'controls.move': 'Move',
  'controls.jump': 'Jump',
  'controls.sprint': 'Sprint',
  'controls.look': 'Look',
  'controls.break': 'Break',
  'controls.place': 'Place',
  'controls.selectBlock': 'Select block',
  'controls.inventory': 'Inventory',
  'controls.craft': 'Craft',
  'controls.mute': 'Mute',
  'controls.lighting': 'Toggle lighting mode',
  'controls.chat': 'Chat',
  'controls.playerList': 'Player list',

  // Player list
  'playerList.title': 'Players Online',
  'playerList.name': 'Name',
  'playerList.position': 'Position',
  'playerList.you': 'you',
  'playerList.count': '{count} players online',

  // HUD
  'hud.oxygen': 'Air',
  'hud.players': 'Players: {count}',
  'hud.position': 'Pos: {x}, {y}, {z}',

  // Death screen
  'death.title': 'You drowned!',
  'death.respawn': 'Click to respawn',

  // World selector
  'world.choose': 'Choose a World',
  'world.players': '{count}/{max} players',
  'world.play': 'Play',
  'world.password': 'Password:',
  'world.ok': 'OK',
  'world.cancel': 'Cancel',

  // Chat / network
  'chat.placeholder': 'Type a message...',
  'chat.playerJoined': '{name} joined',
  'chat.disconnected': 'Connection lost!',
  'chat.reconnecting': 'Reconnecting in {seconds}s... (attempt {attempt})',
  'chat.reconnected': 'New server version, reconnected!',
  'net.connecting': 'WS: connecting...',
  'net.connected': 'WS: connected',
  'net.disconnected': 'WS: disconnected',
  'net.notConnected': 'WS: not connected',
  'net.status': 'WS: connected ({id}) | Chunks: {chunks} | Blk: {sent}/{recv}',

  // Crafting / Inventory
  'crafting.inventory': 'Inventory',
  'crafting.furnace': 'Furnace',
  'crafting.workbench': 'Workbench',
  'crafting.crafting': 'Crafting',
  'crafting.hint': 'Click an item to place it in slot {slot}',
  'crafting.recipeBook': 'Recipe Book',
  'crafting.items': 'Items',

  // Help screen
  'help.title': 'Help',
  'help.resources': 'Resources',
  'help.controls': 'Controls',
  'help.recipes': 'Recipes',
  'help.closeHint': 'Press H or Esc to close',
  'help.helpKey': 'Help screen',
  'help.close': 'Close',
  'help.keySpace': 'Space',
  'help.keyMouse': 'Mouse',
  'help.ores': 'Ores & Minerals',
  'help.coal': 'Everywhere underground, most common near surface (y 140+)',
  'help.iron': 'Mid-depth (y 80-140), also deeper',
  'help.gold': 'Deep (y 30-80), rare',
  'help.diamond': 'Very deep (y < 60), most common below y 30',
  'help.obsidian': 'Deepest layer (y < 30), near lava',
  'help.biomes': 'Biomes',
  'help.forest': 'Oak trees, mushrooms, flowers',
  'help.desert': 'Sand, sandstone, cacti',
  'help.tundra': 'Snow, ice, spruce trees',
  'help.swamp': 'Dark grass, clay, vines',
  'help.mountains': 'Very tall, snow caps, stone surface',
  'help.special': 'Special Blocks',
  'help.flyblock': 'Trampoline — bounces you high into the air',
  'help.superflyblock': 'Super trampoline — 3x higher than Fly Block',
  'help.portal': 'Build two 3x4 frames, they auto-pair. Walk through to teleport!',
  'help.lava': 'Deals damage! Found in caves below y 50',
  'help.water': 'Oceans, lakes, slows movement',
  'help.bed': 'Sleep through the night! All players must be in bed.',
  'help.speedblock': 'Gives 5 seconds of super speed when you walk on it!',
  'help.ice': 'Slippery surface — you slide across!',
  'help.arrowblock': 'Pushes you in the direction of the arrow!',
  'help.launchpad': 'Launches you far through the air! Expensive but powerful travel.',
  'help.paintblocks': 'Walk through for colorful footprints (30 seconds)',
  'help.musicblock': 'Right-click to play notes! 8 tones (C-C).',
  'help.firework': 'Right-click to launch fireworks! Gets consumed.',
  'help.teleportblock': 'Step on it to teleport to a random player!',
  'help.tnt': 'Hit it to light the fuse. Explodes after 3 seconds!',

  // Sleep
  'sleep.sleeping': 'Sleeping...',
  'sleep.playerCount': '{sleeping}/{total} players sleeping',
  'sleep.wakeHint': 'Click to wake up',
  'sleep.notNight': 'You can only sleep at night!',

  // Mobile
  'mobile.rotate': 'Rotate your screen for the best experience',

  // Admin page
  'admin.title': 'JanneCraft Admin',
  'admin.subtitle': 'Admin Panel',
  'admin.password': 'Password',
  'admin.login': 'Log in',
  'admin.back': '← Back to JanneCraft',
  'admin.play': 'Play',
  'admin.stats': 'Stats',
  'admin.admin': 'Admin',
  'admin.logout': 'Log out',
  'admin.serverOverview': 'Server Overview',
  'admin.playersOnline': 'Players Online',
  'admin.worlds': 'Worlds',
  'admin.uptime': 'Uptime',
  'admin.createWorld': 'Create New World',
  'admin.name': 'Name',
  'admin.seedOptional': 'Seed (optional)',
  'admin.seedPlaceholder': 'Random',
  'admin.passwordOptional': 'Password (optional)',
  'admin.passwordPlaceholder': 'None',
  'admin.maxPlayers': 'Max Players',
  'admin.create': 'Create',
  'admin.worldList': 'Worlds',
  'admin.players': 'Players',
  'admin.status': 'Status',
  'admin.seed': 'Seed',
  'admin.actions': 'Actions',
  'admin.loading': 'Loading...',
  'admin.noWorlds': 'No worlds',
  'admin.onlinePlayers': 'Online Players',
  'admin.playerName': 'Name',
  'admin.world': 'World',
  'admin.position': 'Position',
  'admin.noPlayers': 'No players online',
  'admin.backToGame': 'Back to JanneCraft',
  'admin.delete': 'Delete',
  'admin.default': 'Default',
  'admin.confirmDelete': 'Are you sure you want to delete "{name}"?<br>This cannot be undone!',
  'admin.error': 'Error',
  'admin.connectionFailed': 'Connection failed',
  'admin.myWorld': 'My World',
  'admin.none': 'None',
  'admin.badge.default': 'default',
  'admin.badge.locked': 'locked',
  'admin.badge.loaded': 'loaded',
  'admin.badge.unloaded': 'unloaded',
  'admin.size': 'Size',
  'admin.chunks': 'chunks',
  'admin.mods': 'modifications',
  'admin.uniquePlayers': 'Unique Players',
  'admin.allPlayers': 'All Players',
  'admin.lastWorld': 'Last World',
  'admin.uuid': 'UUID',
  'admin.noPlayersEver': 'No players yet',

  // Stats page
  'stats.title': 'JanneCraft',
  'stats.serverStatus': 'Server Status',
  'stats.playersOnline': 'Players Online',
  'stats.connecting': 'Connecting...',
  'stats.noPlayers': 'No players online',
  'stats.uptime': 'Uptime',
  'stats.days': 'days',
  'stats.hours': 'hrs',
  'stats.minutes': 'min',
  'stats.seconds': 'sec',
  'stats.dayNight': 'Day / Night Cycle',
  'stats.sunrise': 'Sunrise',
  'stats.day': 'Day',
  'stats.sunset': 'Sunset',
  'stats.night': 'Night',
  'stats.world': 'World',
  'stats.chunksLoaded': 'Chunks Loaded',
  'stats.worlds': 'Worlds',
  'stats.worldPlayers': '{count}/{max} players',
  'stats.playGame': 'Play JanneCraft',
  'stats.performance': 'Server Performance',
  'stats.memoryUsage': 'Memory (MB)',
  'stats.wsMessages': 'WebSocket Messages/s',
  'stats.wsIn': 'In',
  'stats.wsOut': 'Out',
  'stats.loadedChunks': 'Loaded Chunks',
  'stats.loadedWorlds': 'Loaded Worlds',
  'stats.rss': 'RSS',
  'stats.heap': 'Heap',

  // Block names (block.ID)
  'block.0': 'Air',
  'block.1': 'Grass',
  'block.2': 'Dirt',
  'block.3': 'Stone',
  'block.4': 'Sand',
  'block.5': 'Wood',
  'block.6': 'Leaves',
  'block.7': 'Water',
  'block.8': 'Cobblestone',
  'block.9': 'Planks',
  'block.10': 'Glass',
  'block.11': 'Brick',
  'block.12': 'Snow',
  'block.13': 'Flower',
  'block.14': 'Coal Ore',
  'block.15': 'Iron Ore',
  'block.16': 'Gold Ore',
  'block.17': 'Diamond Ore',
  'block.18': 'Bedrock',
  'block.19': 'Stick',
  'block.20': 'Torch',
  'block.21': 'Iron Ingot',
  'block.22': 'Gold Ingot',
  'block.23': 'Diamond',
  'block.24': 'Crafting Table',
  'block.25': 'Furnace',
  'block.26': 'Wooden Pickaxe',
  'block.27': 'Iron Pickaxe',
  'block.28': 'Coal',
  'block.29': 'Sandstone',
  'block.30': 'Ice',
  'block.31': 'Cactus',
  'block.32': 'Mushroom',
  'block.33': 'Tall Grass',
  'block.34': 'Spruce Wood',
  'block.35': 'Spruce Leaves',
  'block.36': 'Birch Wood',
  'block.37': 'Birch Leaves',
  'block.38': 'Dark Grass',
  'block.39': 'Vine',
  'block.40': 'Lava',
  'block.41': 'Gravel',
  'block.42': 'Obsidian',
  'block.43': 'Clay',
  'block.44': 'Fly Block',
  'block.45': 'Super Fly Block',
  'block.46': 'Portal Stone',
  'block.47': 'Portal Surface',
  'block.48': 'Bed',
  'block.49': 'Bed Head',
  'block.50': 'Launch Pad',
  'block.51': 'Red Paint',
  'block.52': 'Blue Paint',
  'block.53': 'Green Paint',
  'block.54': 'Yellow Paint',
  'block.55': 'Arrow Block',
  'block.56': 'Arrow Block East',
  'block.57': 'Arrow Block South',
  'block.58': 'Arrow Block West',
  'block.59': 'Music Block',
  'block.60': 'Teleport Block',
  'block.61': 'TNT',
  'block.62': 'Fireworks',
  'block.63': 'Speed Block',

  // Model types (model.ID)
  'model.0': 'Boy',
  'model.1': 'Girl',
  'model.2': 'Robot',
  'model.3': 'Skeleton',
  'model.4': 'Alien',
  'model.5': 'Pumpkin',
  'model.6': 'Ninja',
};
